import type { Instrument } from '../services/api';

/**
 * 本地开发 / 接口无数据时用于预览仪器橱窗 UI（请勿在生产环境依赖）。
 */
export const MOCK_INSTRUMENTS: Instrument[] = [
  {
    _id: 'mock-ins-1',
    name: 'Q Exactive 高分辨质谱',
    model: 'Q Exactive HF-X',
    manufacturer: 'Thermo Fisher',
    location: '核心仪器室 A 区 · 04 台',
    status: '可用',
    category: '分析仪器',
    description: '高分辨质谱，适用于蛋白质组学与代谢组学高通量定性定量分析。',
    responsiblePerson: '李研究员',
    image:
      'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-2',
    name: '高通量基因测序仪',
    model: 'NovaSeq 6000',
    manufacturer: 'Illumina',
    location: '测序间 B-12',
    status: '使用中',
    category: '生命科学',
    description: '超高通量测序平台，支持全基因组与单细胞测序项目。',
    responsiblePerson: '王博士',
    image:
      'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-3',
    name: '激光共聚焦显微镜',
    model: 'LSM 880',
    manufacturer: 'Zeiss',
    location: '成像平台 C-08',
    status: '维护中',
    category: '显微镜成像',
    description: '活细胞长时程成像与共定位分析，配备 Airyscan 超分辨模块。',
    responsiblePerson: '陈工',
    image:
      'https://images.unsplash.com/photo-1532187863486-cfcb86cd192f?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-4',
    name: '超速离心机',
    model: 'Optima XPN-100',
    manufacturer: 'Beckman Coulter',
    location: '样品前处理间',
    status: '可用',
    category: '通用设备',
    description: '台式超速离心，适用于病毒颗粒与细胞器分离。',
    responsiblePerson: '赵老师',
    image:
      'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-5',
    name: '实时荧光定量 PCR',
    model: 'CFX96 Touch',
    manufacturer: 'Bio-Rad',
    location: '分子生物学实验室 2',
    status: '可用',
    category: '生命科学',
    description: '96 孔 qPCR，支持基因表达与 SNP 分型常规检测。',
    responsiblePerson: '刘技师',
    image:
      'https://images.unsplash.com/photo-1579165466741-7f35a4755657?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-6',
    name: '流式细胞分选仪',
    model: 'FACSAria Fusion',
    manufacturer: 'BD',
    location: '流式细胞室 D1',
    status: '可用',
    category: '分析仪器',
    description: '四激光多色分选，适用于免疫细胞亚群分析与单细胞分选。',
    responsiblePerson: '孙 PI',
    image:
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-7',
    name: '冷冻透射电镜',
    model: 'Krios G4',
    manufacturer: 'Thermo Fisher',
    location: '电镜中心 负一层',
    status: '故障',
    category: '显微镜成像',
    description: '冷冻电镜单颗粒分析，暂时停机等待冷场发射源更换。',
    responsiblePerson: '周工程师',
    image:
      'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-8',
    name: '纳米粒度及 Zeta 电位仪',
    model: 'Zetasizer Pro',
    manufacturer: 'Malvern Panalytical',
    location: '理化表征间',
    status: '可用',
    category: '分析仪器',
    description: '胶体与纳米颗粒粒径、PDI 及表面电位表征。',
    responsiblePerson: '吴老师',
    image:
      'https://images.unsplash.com/photo-1532094340224-2c290a616144?w=900&h=600&fit=crop'
  },
  {
    _id: 'mock-ins-9',
    name: '原位显微拉曼',
    model: 'inVia Reflex',
    manufacturer: 'Renishaw',
    location: '—',
    status: '报废',
    category: '',
    description: '已下线设备，仅供档案与培训示意（未分类条目示例）。',
    responsiblePerson: '—',
    image: '/default-instrument.jpg'
  }
];
